import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 24px;
  overflow: hidden;
  pointer-events: none;
  z-index: 2000;
`;
